import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const KINDS = [
  { key: "divisions", label: "Divisi" },
  { key: "positions", label: "Jabatan" },
  { key: "locations", label: "Lokasi Kerja" },
  { key: "statuses", label: "Status Karyawan" },
  { key: "shifts", label: "Shift / Jam Kerja" },
];
const DAYS = ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"];

export default function HrMasters({ initialKind = "divisions" }) {
  const [kind, setKind] = useState(initialKind);
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ name: "" });
  const [shift, setShift] = useState({ start_time: "08:00", end_time: "17:00", break_minutes: "60", grace_minutes: "10", working_days: ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab"], effective_date: "" });

  const load = () => api.get(`/hr/masters/${kind}`).then((r) => setRows(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); setF({ name: "" }); /* eslint-disable-next-line */ }, [kind]);

  const add = async () => {
    if (!f.name.trim()) return toast.error("Nama wajib diisi");
    const body = { name: f.name };
    if (kind === "shifts") Object.assign(body, { ...shift, break_minutes: Number(shift.break_minutes || 0), grace_minutes: Number(shift.grace_minutes || 0) });
    try { await api.post(`/hr/masters/${kind}`, body); toast.success("Tersimpan"); setF({ name: "" }); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const toggleDay = (d) => setShift({ ...shift, working_days: shift.working_days.includes(d) ? shift.working_days.filter((x) => x !== d) : [...shift.working_days, d] });

  return (
    <div className="p-6" data-testid="hr-masters-page">
      <h1 className="text-2xl font-semibold text-white mb-1">Data Master HR</h1>
      <p className="text-slate-400 text-sm mb-4">Divisi, Jabatan, Lokasi, Status Karyawan, dan Shift / Jam Kerja.</p>
      <div className="flex gap-2 mb-4 flex-wrap">
        {KINDS.map((k) => <button key={k.key} data-testid={`tab-${k.key}`} onClick={() => setKind(k.key)} className={`px-3 py-2 rounded text-sm ${kind === k.key ? "bg-indigo-600 text-white" : "bg-slate-800 text-slate-300"}`}>{k.label}</button>)}
      </div>

      <Card className="p-4 bg-slate-900 border-slate-800 mb-4">
        <div className="flex flex-wrap items-end gap-3">
          <div><label className="text-xs text-slate-400">Nama</label><Input data-testid="master-name" value={f.name} onChange={(e) => setF({ name: e.target.value })} className="bg-slate-800 border-slate-700 text-white w-56" /></div>
          {kind === "shifts" && (
            <>
              <div><label className="text-xs text-slate-400">Mulai</label><Input type="time" value={shift.start_time} onChange={(e) => setShift({ ...shift, start_time: e.target.value })} className="bg-slate-800 border-slate-700 text-white w-28" /></div>
              <div><label className="text-xs text-slate-400">Selesai</label><Input type="time" value={shift.end_time} onChange={(e) => setShift({ ...shift, end_time: e.target.value })} className="bg-slate-800 border-slate-700 text-white w-28" /></div>
              <div><label className="text-xs text-slate-400">Istirahat (mnt)</label><Input type="number" value={shift.break_minutes} onChange={(e) => setShift({ ...shift, break_minutes: e.target.value })} className="bg-slate-800 border-slate-700 text-white w-24" /></div>
              <div><label className="text-xs text-slate-400">Toleransi (mnt)</label><Input type="number" value={shift.grace_minutes} onChange={(e) => setShift({ ...shift, grace_minutes: e.target.value })} className="bg-slate-800 border-slate-700 text-white w-24" /></div>
              <div><label className="text-xs text-slate-400">Berlaku Sejak</label><Input type="date" value={shift.effective_date} onChange={(e) => setShift({ ...shift, effective_date: e.target.value })} className="bg-slate-800 border-slate-700 text-white" /></div>
              <div><label className="text-xs text-slate-400 block mb-1">Hari Kerja</label><div className="flex gap-1">{DAYS.map((d) => <button key={d} type="button" onClick={() => toggleDay(d)} className={`px-2 py-1 rounded text-xs ${shift.working_days.includes(d) ? "bg-indigo-600 text-white" : "bg-slate-800 text-slate-400"}`}>{d}</button>)}</div></div>
            </>
          )}
          <Button data-testid="add-master-btn" onClick={add} className="bg-emerald-600 hover:bg-emerald-500">Tambah</Button>
        </div>
      </Card>

      <Card className="p-0 bg-slate-900 border-slate-800 overflow-x-auto">
        <table className="w-full text-sm text-slate-300">
          <thead><tr className="text-left text-slate-500 border-b border-slate-800"><th className="p-3">Nama</th>{kind === "shifts" && <><th>Jam</th><th>Istirahat</th><th>Toleransi</th><th>Hari</th></>}</tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={kind === "shifts" ? 5 : 1} className="p-6 text-center text-slate-500">Belum ada data.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`master-row-${r.id}`} className="border-b border-slate-800">
                <td className="p-3">{r.name}</td>
                {kind === "shifts" && <><td>{r.start_time}–{r.end_time}</td><td>{r.break_minutes} mnt</td><td>{r.grace_minutes} mnt</td><td className="text-xs">{(r.working_days || []).join(", ")}</td></>}
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
